import React from "react";

const SortMobileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
    >
      <path
        d="M11.4583 18.3166C10.9831 18.3166 10.5274 18.128 10.1914 17.7922C9.8554 17.4565 9.66664 17.0012 9.66664 16.5264C9.66664 16.0516 9.8554 15.5962 10.1914 15.2605C10.5274 14.9248 10.9831 14.7362 11.4583 14.7362H19.8194C20.2946 14.7362 20.7503 14.9248 21.0863 15.2605C21.4223 15.5962 21.6111 16.0516 21.6111 16.5264C21.6111 17.0012 21.4223 17.4565 21.0863 17.7922C20.7503 18.128 20.2946 18.3166 19.8194 18.3166H11.4583ZM1.90275 11.1558C1.42757 11.1558 0.971854 10.9671 0.635851 10.6314C0.299848 10.2957 0.111084 9.84035 0.111084 9.36556C0.111084 8.89077 0.299848 8.43542 0.635851 8.09969C0.971854 7.76397 1.42757 7.57536 1.90275 7.57536H19.8194C20.2946 7.57536 20.7503 7.76397 21.0863 8.09969C21.4223 8.43542 21.6111 8.89077 21.6111 9.36556C21.6111 9.84035 21.4223 10.2957 21.0863 10.6314C20.7503 10.9671 20.2946 11.1558 19.8194 11.1558H1.90275ZM1.90275 3.99495C1.42757 3.99495 0.971854 3.80634 0.635851 3.47062C0.299848 3.13489 0.111084 2.67954 0.111084 2.20475C0.111084 1.72996 0.299848 1.27462 0.635851 0.938889C0.971854 0.603161 1.42757 0.414551 1.90275 0.414551L10.2639 0.414551C10.739 0.414551 11.1948 0.603161 11.5308 0.938889C11.8668 1.27462 12.0555 1.72996 12.0555 2.20475C12.0555 2.67954 11.8668 3.13489 11.5308 3.47062C11.1948 3.80634 10.739 3.99495 10.2639 3.99495H1.90275Z"
        fill={"#0085FF"}
      />
    </svg>
  );
};

export default SortMobileIcon;
